import { StatusEnum } from '../status';
import { IGradeUnitDTO, IUnitCoverImage } from './grade-unit';
import { EdReviewNoteDto } from '@models/ed-review';

export interface IGradeUnitDayDTO {
  id: number;
  unitId: number;
  unitNumber: number;
  unitGradeLevel: string;
  gradeNumber: number;
  dayTitle: string;
  dayNumber: number;
  dayStartPage: string;
  dayEndPage: string;
  dayCoverImage: IUnitCoverImage;
  isQuiz: boolean;
  edReviews: EdReviewNoteDto[];
  unit?: IGradeUnitDTO;
}

export class GradeUnitDayDTO implements IGradeUnitDayDTO {
  id: number = null;
  unitId: number = null;
  unitNumber: number = null;
  unitGradeLevel: string = '';
  gradeNumber: number = null;
  dayTitle: string = '';
  dayNumber: number = null;
  dayStartPage: string = '';
  dayEndPage: string = '';
  dayCoverImage: IUnitCoverImage;
  isQuiz: boolean = false;
  edReviews: EdReviewNoteDto[] = [];
  unit?: IGradeUnitDTO = null;

  constructor(configOverride?: Partial<IGradeUnitDayDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IGradeUnitDayListItemDTO {
  dayId: number;
  unitNumber: number;
  gradeNumber: number;
  dayNumber: number;
  dayTitle: string;
  dayStartPage: string;
  dayEndPage: string;
  dayCoverImageId: string;
  dayCoverImageUrl: string;
  status?: StatusEnum;
  dayStatus?: StatusEnum;
  edReviews: EdReviewNoteDto[];
  isQuiz?: boolean;
}

export class GradeUnitDayListItemDTO implements IGradeUnitDayListItemDTO {
  dayId: number = null;
  unitNumber: number = null;
  gradeNumber: number = null;
  dayNumber: number = null;
  dayTitle: string = '';
  dayStartPage: string = '';
  dayEndPage: string = '';
  dayCoverImageId: string = '';
  dayCoverImageUrl: string = '';
  status?: StatusEnum = StatusEnum.NULL_STATUS;
  edReviews: EdReviewNoteDto[] = [];
  isQuiz?: boolean;

  constructor(configOverride?: Partial<IGradeUnitDayListItemDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IGradeUnitDayRequest {
  dayTitle: string;
  dayNumber: number;
  dayStartPage: string;
  dayEndPage?: string;
  dayCoverImage: FileList;
  dayStatus?: StatusEnum;
  isQuiz: boolean;
}

export class GradeUnitDayRequest implements IGradeUnitDayRequest {
  dayTitle: string = '';
  dayNumber: number = null;
  dayStartPage: string = '';
  dayEndPage?: string = '';
  dayCoverImage: FileList = null;
  dayStatus?: StatusEnum = StatusEnum.INPROGRESS;
  isQuiz: boolean = false;

  constructor(configOverride?: Partial<IGradeUnitDayRequest>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
